export default function cleanFormEmptyFields<T extends Record<string, any>>(obj: T) {
  return Object.entries(obj).reduce((acc, [key, value]) => {
    const isValidValue = value || value === 0 || value === false;
    if (isValidValue) {
      acc[key as keyof T] = value;
    }
    return acc;
  }, {} as T);
}
